import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { FormDataService } from 'src/app/shared/form-data.service';
import EcUtils from 'src/app/shared/ecutils';

@Component({
  selector: 'app-collect-answer',
  templateUrl: './collect-answer.component.html',
  styleUrls: ['./collect-answer.component.scss']
})
export class CollectAnswerComponent implements OnInit {

  questions = [];
  answers = [];
  questionsForm: FormGroup;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private formBuilder: FormBuilder

  ) { }
  ngOnInit() {
    this.questionsForm = this.formBuilder.group({});
    this.questions = this.formDataService.getPhase2Questions();

    this.questions.forEach (( q , i ) => {
      const fc: FormControl = new FormControl(q.Answer);
      this.questionsForm.addControl(q.qn_number, fc);
    });
  }

  bindAnswers() {
    Object.keys(this.questionsForm.controls).forEach(key => {
      this.questions.forEach( (q, i ) => {
        if (q.qn_number === key ) {
          if ( q.answer_type === 'date') {
            q.Answer = EcUtils.format(this.questionsForm.controls[key].value);
          } else {
            q.Answer = this.questionsForm.controls[key].value;
          }
        }
      });
    });

  }

  submit() {
    this.bindAnswers();
    const http$ = this.formDataService.sendPhase2Data();
    http$.subscribe(res => {
      this.router.navigate(['../response'], { relativeTo: this.route});
    }, err => {
      console.log(err);
      this.router.navigate(['../response'], { relativeTo: this.route});
    });
  }

}
